module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800px"
    },
    model: {
      value: (_vm.showCompliance),
      callback: function($$v) {
        _vm.showCompliance = $$v
      },
      expression: "showCompliance"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "complianceForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveCompliance(_vm.lCompliance.action)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n                " + _vm._s(_vm.lCompliance.action) + " Compliance\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name *",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lCompliance.name),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "name", $$v)
      },
      expression: "lCompliance.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.complianceTypeList,
      "item-text": "name",
      "item-value": "compliance_type_id",
      "label": "Compliance Type *",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lCompliance.compliance_type_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_type_id", $$v)
      },
      expression: "lCompliance.compliance_type_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.complianceCategoryList,
      "item-text": "name",
      "item-value": "id",
      "label": "Compliance Category *",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": _vm.onComplianceCategoryChange
    },
    model: {
      value: (_vm.lCompliance.compliance_category_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_category_id", $$v)
      },
      expression: "lCompliance.compliance_category_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.filteredComplianceSubcategories,
      "item-text": "name",
      "item-value": "id",
      "label": "Compliance Subcategory *",
      "rules": [_vm.rules.required],
      "disabled": !_vm.lCompliance.compliance_category_id
    },
    model: {
      value: (_vm.lCompliance.compliance_subcategory_id),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "compliance_subcategory_id", $$v)
      },
      expression: "lCompliance.compliance_subcategory_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Yearly', 'Half-yearly', 'Quarterly', 'Monthly', 'Onetime'],
      "label": "Frequency *",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lCompliance.frequency),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "frequency", $$v)
      },
      expression: "lCompliance.frequency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Valid From (Start/Issue Date) *",
            "readonly": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.lCompliance.valid_from),
            callback: function($$v) {
              _vm.$set(_vm.lCompliance, "valid_from", $$v)
            },
            expression: "lCompliance.valid_from"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.validFromMenu),
      callback: function($$v) {
        _vm.validFromMenu = $$v
      },
      expression: "validFromMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.validFromMenu = false
      }
    },
    model: {
      value: (_vm.lCompliance.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "valid_from", $$v)
      },
      expression: "lCompliance.valid_from"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Valid To (Expiry Date) *",
            "readonly": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.lCompliance.valid_to),
            callback: function($$v) {
              _vm.$set(_vm.lCompliance, "valid_to", $$v)
            },
            expression: "lCompliance.valid_to"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.validToMenu),
      callback: function($$v) {
        _vm.validToMenu = $$v
      },
      expression: "validToMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": _vm.lCompliance.valid_from
    },
    on: {
      "input": function($event) {
        _vm.validToMenu = false
      }
    },
    model: {
      value: (_vm.lCompliance.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "valid_to", $$v)
      },
      expression: "lCompliance.valid_to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Notify Before Days",
      "type": "number",
      "min": "0",
      "hint": "Number of days before expiry to send notification"
    },
    model: {
      value: (_vm.lCompliance.notify_before_days),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "notify_before_days", _vm._n($$v))
      },
      expression: "lCompliance.notify_before_days"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Remarks",
      "rows": "3",
      "hint": "Additional notes or comments"
    },
    model: {
      value: (_vm.lCompliance.remarks),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "remarks", $$v)
      },
      expression: "lCompliance.remarks"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Show on Dashboard",
      "color": "primary"
    },
    model: {
      value: (_vm.lCompliance.show_dashboard),
      callback: function($$v) {
        _vm.$set(_vm.lCompliance, "show_dashboard", $$v)
      },
      expression: "lCompliance.show_dashboard"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pa-0"
  }, [_vm._v("Attachments")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser()
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lCompliance.files && _vm.lCompliance.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lCompliance.files), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n                          " + _vm._s(file.file_name) + "\n                          "), _vm._v(" "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.FM_SPACES_BASE_URL + file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("\n                      Attachment if any"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(supports images, pdfs, docs and excels upto 20MB)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lCompliance.action === 'Update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteCompliance(_vm.lCompliance)
      }
    }
  }, [_vm._v("\n                  Delete\n                ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("\n                  Save\n                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-298ae146","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Compliance.vue
// module id = 846
// module chunks = 13